import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const EditIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M11.1504 17.4739H18.0001" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M10.2367 1.75064C10.9692 0.875132 12.2861 0.746752 13.1798 1.46441C13.2292 1.50335 14.8167 2.73663 14.8167 2.73663C15.7985 3.33013 16.1035 4.59182 15.4967 5.55467C15.4644 5.60623 6.48906 16.8331 6.48906 16.8331C6.19045 17.2056 5.73717 17.4256 5.25275 17.4308L1.81555 17.474L1.04111 14.1961C0.932626 13.7352 1.04111 13.2511 1.33972 12.8786L10.2367 1.75064Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M8.5752 3.83423L13.7245 7.78874" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg {...props} fill="none" stroke="currentColor" width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};